import React from "react";
import { ShieldAlert } from "lucide-react";

/**
 * Counseling safety disclaimer — surfaced on every counseling-related landing page.
 * Tone: tasteful, clear, non-alarmist. Not a wall of legalese.
 */
const CounselingDisclaimer = () => (
  <aside
    className="my-12 bento-card !p-6 sm:!p-8 border-[#C9A44C]/25"
    role="note"
    aria-label="Counseling safety disclaimer"
    data-testid="counseling-disclaimer"
  >
    <span className="glow-blob" />
    <div className="flex items-start gap-4">
      <span className="icon-badge !h-10 !w-10 shrink-0">
        <ShieldAlert className="h-5 w-5 text-[#F28C18]" strokeWidth={1.6} />
      </span>
      <div>
        <div className="overline mb-2 !text-[#F28C18]">A note on care &amp; safety</div>
        <p className="text-sm text-[#D9D9D9] leading-relaxed">
          Revival Fire Ministries Global provides biblical guidance, pastoral care,
          prayer, and spiritual support. This does not replace emergency services,
          licensed medical care, licensed mental health care, or legal counsel.
          If you are in danger or facing an emergency, please contact local emergency
          services immediately.
        </p>
      </div>
    </div>
  </aside>
);

export default CounselingDisclaimer;
